export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20interior%20with%20warm%20golden%20spotlight%20illuminating%20rich%20crimson%20red%20velvet%20curtains%20dramatic%20shadows%20elegant%20art%20deco%20architectural%20details%20luxurious%20vintage%20cinema%20atmosphere%20with%20rich%20crimson%20and%20deep%20gold%20tones%20photorealistic%208K%20render%20with%20soft%20atmospheric%20lighting%20and%20subtle%20film%20grain%20texture%20centered%20composition%20with%20depth%20and%20grandeur&width=1600&height=900&seq=hero-bg-8848&orientation=landscape"
          alt="8848影院 — 电视剧全集免费在线观看平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">
                全网热播剧集 · 全集免费观看
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight tracking-tight">
              8848影院
              <br className="md:hidden" />
              <span className="text-primary-400"> · 全集追剧不等待</span>
            </h1>

            <p className="text-base md:text-lg font-medium text-white/80 mt-4 mb-6 leading-relaxed max-w-xl lg:max-w-none">
              国产剧全集、韩剧全集、美剧全集一站式在线观看。告别周更等待，高清画质一次看完全集。
              从经典老剧到最新热播，从古装权谋到现代都市，超过5000部电视剧全集覆盖你的所有追剧需求。
              无需注册、无需付费，打开8848影院，即刻开启你的追剧之旅。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-8">
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-movie-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">
                  <strong className="text-accent-300 text-base">5,000+</strong> 部剧集收录
                </span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-4k-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">
                  <strong className="text-accent-300 text-base">1080P</strong> 高清画质
                </span>
              </div>
              <div className="flex items-center gap-2 text-white/70">
                <i className="ri-time-line text-accent-400 text-lg"></i>
                <span className="text-sm font-medium whitespace-nowrap">
                  <strong className="text-accent-300 text-base">每日更新</strong> 50+集
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all hover:scale-[1.02] whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#carousel"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold text-sm rounded-lg border border-white/25 transition-all hover:scale-[1.02] whitespace-nowrap"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-layout-grid-line text-lg"></i>
                浏览精选专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none flex justify-center">
            <div className="relative w-64 h-80 md:w-72 md:h-96 lg:w-80 lg:h-[420px] rounded-xl overflow-hidden ring-2 ring-white/15 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Stunning%20cinematic%20movie%20poster%20collage%20featuring%20dramatic%20compositions%20from%20various%20TV%20drama%20genres%20Chinese%20period%20drama%20Korean%20romance%20American%20thriller%20rich%20warm%20crimson%20gold%20and%20amber%20color%20palette%20elegant%20film%20poster%20layout%20with%20sophisticated%20typography%20space%20dark%20cinematic%20mood%20vertical%20format&width=720&height=960&seq=hero-poster&orientation=portrait"
                alt="8848影院 — 热门电视剧精选合集海报"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <span className="text-xs font-label font-semibold text-accent-300 uppercase tracking-wider">
                  热播精选
                </span>
                <p className="text-white text-sm font-medium mt-1 leading-snug">
                  长安十二时辰 · 黑暗荣耀 · 繁花
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}